import { CircleNotch } from "@phosphor-icons/react";

export const Spinner = ({ className = "" }) => (
  <CircleNotch size={32} className={`animate-spin text-primary ${className}`} weight="bold" aria-hidden />
);

export const SkeletonCard = () => (
  <div className="min-w-[260px] overflow-hidden rounded-2xl border border-stone-200 bg-white">
    <div className="h-40 animate-pulse bg-stone-200" />
    <div className="space-y-3 p-4">
      <div className="h-4 w-3/4 animate-pulse rounded bg-stone-200" />
      <div className="h-3 w-1/2 animate-pulse rounded bg-stone-200" />
      <div className="h-5 w-1/3 animate-pulse rounded bg-stone-200" />
    </div>
  </div>
);

export const SkeletonRow = () => (
  <div className="flex items-center gap-4 rounded-xl border border-stone-200 bg-white p-4">
    <div className="h-14 w-14 animate-pulse rounded-lg bg-stone-200" />
    <div className="flex-1 space-y-2">
      <div className="h-4 w-1/3 animate-pulse rounded bg-stone-200" />
      <div className="h-3 w-1/4 animate-pulse rounded bg-stone-200" />
    </div>
  </div>
);

export const StatSkeleton = () => (
  <div className="rounded-2xl border border-stone-200 bg-white p-6">
    <div className="h-3 w-2/3 animate-pulse rounded bg-stone-200" />
    <div className="mt-4 h-8 w-1/2 animate-pulse rounded bg-stone-200" />
  </div>
);
